export default __webpack_public_path__ + "static/media/template-active.4e591f67.svg";